
  import {Component, Vue, Prop} from 'vue-property-decorator';
  import {
    Action,
  } from 'vuex-class';

  @Component
  export default class DlgCeoDelete extends Vue {
    @Prop({type: Object, default: null}) private ceo!: object;

    @Action('admin/ceos/remove') private ceoDel!: any;
    @Action('admin/ceos/read') private read!: any;

    private dialog: boolean = false;
    private loading: boolean = false;

    private async del() {
      this.loading = true;
      const res = await this.ceoDel(this.ceo);
      if (res) {
        this.read();
        this.dialog = false;
      }
      this.loading = false;
    }
  }
